import React from "react";
const SvgMapDraw = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#1A1F24"
      fillRule="evenodd"
      d="M12.534 2c-2.62-.082-5.306 1.918-6.442 5.165a.5.5 0 11-.944-.33C6.392 3.282 9.406.902 12.565 1c2.2.065 3.763 1.314 4.39 1.878a.5.5 0 11-.67.743c-.573-.516-1.911-1.567-3.75-1.621zm-.594 4.01c-.752 0-1.41.654-1.41 1.5v7.33a.5.5 0 01-.862.345L8.62 14.086c-.578-.602-1.45-.703-2.018-.255-.644.516-.786 1.46-.349 2.15l2.59 4.06A2.028 2.028 0 0010.54 21h5.85c.03 0 .06.003.09.008.978-.046 1.815-.831 1.944-1.898l.57-4.74c.14-1.173-.638-2.225-1.708-2.407l-3.52-.6a.5.5 0 01-.416-.493V7.51c0-.846-.657-1.5-1.41-1.5zM16.29 22h-5.75a3.026 3.026 0 01-2.542-1.422l-2.59-4.06c-.703-1.11-.485-2.625.57-3.469l.002-.002c1.052-.83 2.5-.55 3.36.346l.002.002.188.197V7.51c0-1.355 1.063-2.5 2.41-2.5 1.348 0 2.41 1.145 2.41 2.5v2.938l3.104.529c1.63.278 2.732 1.846 2.532 3.512l-.57 4.74c-.187 1.562-1.463 2.78-3.026 2.78a.507.507 0 01-.1-.01z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMapDraw;
